import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";
import { PermissionGuard } from "../guards/permisson.guard";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "password",
        loadChildren: () =>
          import("../main/password/password.module").then(
            (m) => m.PasswordModule
          ),
      },
      {
        path: "user-management",
        canActivate: [PermissionGuard],
        data: { access: "users" },
        loadChildren: () =>
          import("../main/user-management/user-management.module").then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: "rating",
        canActivate: [PermissionGuard],
        data: { access: "users" },
        loadChildren: () =>
          import("../main/feedback-management/feedback-management.module").then(
            (m) => m.FeedbackManagementModule
          ),
      },
      {
        path: "roles",
        canActivate: [PermissionGuard],
        data: { access: "roles" },
        loadChildren: () =>
          import("../main/roles/roles.module").then((m) => m.RolesModule),
      },

      {
        path: "profile",
        canActivate: [PermissionGuard],
        data: { access: "passengers" },
        loadChildren: () =>
          import("../main/profile-management/profile-management.module").then(
            (m) => m.ProfileManagementModule
          ),
      },
      {
        path: "category",
        canActivate: [PermissionGuard],
        data: { access: "passengers" },
        loadChildren: () =>
          import("../main/category-management/category-management.module").then(
            (m) => m.CategoryManagementModule
          ),
      },
      {
        path: "payment-management",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/payment-management/payment-management.module").then(
            (m) => m.PaymentManagementModule
          ),
      },
      {
        path: "order",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/order-management/order-management.module").then(
            (m) => m.OrderManagementModule
          ),
      },
      {
        path: "fare",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/fare-management/fare-management.module").then(
            (m) => m.FareManagementModule
          ),
      },
      {
        path: "promo",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/promo-management/promo-management.module").then(
            (m) => m.PromoManagementModule
          ),
      },
      {
        path: "banner",
        canActivate: [PermissionGuard],
        data: { access: "passengers" },
        loadChildren: () =>
          import("../main/banner-management/banner-management.module").then(
            (m) => m.BannerManagementModule
          ),
      },
      {
        path: "pickdrop",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/pickdrop-management/pickdrop-management.module").then(
            (m) => m.PickdropManagementModule
          ),
      },
      {
        path: "menu",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/menu-management/merchant-management.module").then(
            (m) => m.MenuManagementModule
          ),
      },
      {
        path: "merchant",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/merchant-management/merchant-management.module").then(
            (m) => m.MerchantManagementModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
